export const sellingAgreementsFilterFields = {
  SELLER_REGISTER_CODE: 'sellerRegisterCode',
  BUYER_REGISTER_CODE: 'buyerRegisterCode',
  FINAL_CONSUMPTION_YEAR: 'finalConsumptionYear',
  FUEL_TYPE: 'fuelType',
  FUEL_GENERATION: 'fuelGeneration',
  AGREEMENT_TYPE: 'agreementType',
  STATUS: 'status',
};

export const FORM_ACCOUNT_GOS_SELLING_AGREEMENTS_FILTER =
  'FORM_ACCOUNT_GOS_SELLING_AGREEMENTS_FILTER';
